/* Stylesheet */

.treatment_line_filter {
  position: relative;
  z-index: 1000;
}

.backdrop {
  position: fixed;
  opacity: 0;
  height: 100%;
  top: 0;
  cursor: default;
}
